import BaseObject from '../../../base/base_object';
import RealGameSequenceInitializer from './real_game_sequence_initializer';
import AnonymousGameSequenceInitializer from './anonymous_game_sequence_initializer';
import HistoryGameSequenceInitializer from './history_game_sequence_initializer';
import GameServiceSequenceRunner from './game_service_sequence_runner';
import LoadingIndicator from '../../../components/loading_indicator/loading_indicator';
import LoadingIndicatorEmbedded from '../../../components/loading_indicator/loading_indicator_embedded';



export default class GameServiceDependenciesFactory extends BaseObject {
    static CLASS = 'GameServiceDependenciesFactory';
    init(params) {
        super.init(params);
        if (!params.getServiceFactoryCallback) {
            this.throwArgumentExpected('16', 'init', 'getServiceFactoryCallback');
        }
        this.getServiceFactoryCallback = params.getServiceFactoryCallback;
    }

    realGameSequenceInitializer() {
        return RealGameSequenceInitializer.create({
            serviceFactory: this.getServiceFactoryCallback()
        });
    }
    anonymousGameSequenceInitializer() {
        return AnonymousGameSequenceInitializer.create({
            serviceFactory: this.getServiceFactoryCallback()
        });
    }
    historyGameSequenceInitializer() {
        return HistoryGameSequenceInitializer.create({
            serviceFactory: this.getServiceFactoryCallback()
        });
    }

    gameSequenceRunner() {
        return GameServiceSequenceRunner.create({
            serviceFactory: this.getServiceFactoryCallback()
        });
    }

    loadingIndicator() {
        return LoadingIndicator.create();
    }

    loadingIndicatorEmbedded() {
        return LoadingIndicatorEmbedded.create();
    }
}